<angular-editor
	#editor
	[placeholder]="placeholder"
	[(ngModel)]="value"
	[config]="editorConfig"
	[attr.readonly-editor]="readonly"
></angular-editor>
